export default __webpack_public_path__ + "static/media/no-file.d0101e05.svg";